import OneTable from './OneTable.vue'

OneTable.install = function(Vue) {
  Vue.component(OneTable.name, OneTable)
}

export default OneTable
